import React, { useState, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import "../../style/ThemeList.css";

const themeList = [
  {
    color: [
      [86, 12, 102],
      [112, 143, 255],
    ],
    name: "Space",
  },
  {
    color: [
      [0, 0, 0],
      [255, 255, 255],
    ],
    name: "Black & White",
  },
  {
    color: [
      [84, 247, 84],
      [194, 213, 255],
      [232, 77, 77],
    ],
    name: "Heat",
  },
  {
    color: [
      [81, 0, 128],
      [81, 0, 128],
      [81, 0, 128],
      [81, 0, 128],
      [81, 0, 128],
      [255, 225, 0],
      [81, 0, 128],
      [81, 0, 128],
      [81, 0, 128],
      [81, 0, 128],
      [81, 0, 128],
      [255, 225, 0],
      [81, 0, 128],
      [81, 0, 128],
      [81, 0, 128],
      [81, 0, 128],
      [81, 0, 128],
    ],
    name: "Cosmic",
  },
  {
    color: [
      [158, 218, 222],
      [116, 156, 204],
      [158, 218, 222],
      [116, 156, 204],
      [158, 218, 222],
    ],
    name: "Wave",
  },
  {
    color: [
      [41, 36, 42],
      [199, 40, 40],
      [34, 29, 35],
    ],
    name: "Lava",
  },
  {
    color: [
      [41, 36, 42],
      [34, 29, 35],
      [255, 0, 0],
    ],
    name: "Volcano",
  },
];
const formatRGB = ([r, g, b]) => `rgb(${r}, ${g}, ${b})`;


const ThemeList = ({ onClick, selectedTheme = "Space" }) => {
  const [selected, setSelected] = useState(selectedTheme);

  const handleClick = (theme) => {
    setSelected(theme.name);
    onClick(theme);
  };


  return (
    <ul className="theme_list">
      {themeList.map((theme) => {
        const gradient = `linear-gradient(135deg, ${theme.color
          .map(formatRGB)
          .join(", ")})`;

        return (
          <li key={theme.name} className="theme_element">
            <button
              onClick={() => handleClick(theme)}
              className={`theme_button ${
                selected === theme.name ? "active" : ""
              }`}
              title={theme.name}
            >
              <div
                className="theme_preview"
                style={{
                  background: gradient,
                }}
              />
            </button>
          </li>
        );
      })}
    </ul>
  );
};

ThemeList.propTypes = {
  onClick: PropTypes.func.isRequired,
  selectedTheme: PropTypes.string,
};

export default ThemeList;
